import { classNames } from '@dimjs/utils';
import { ReactNode } from 'react';
import { FlexLayout } from '../flex-layout';
import { CommonPropsWithChildren, withNativeProps } from '../utils';
import './style.less';

export type TimelineItemProps = {
  label?: ReactNode;
  icon?: ReactNode;
  hideIcon?: boolean;
} & CommonPropsWithChildren;

/**
 * @deprecated 请使用Timeline2Item组件替换
 */
export const TimelineItem = (props: TimelineItemProps) => {
  return withNativeProps(
    props,
    <div className={classNames('v-timeline-item', { 'v-timeline-item-hide-icon': props.hideIcon })}>
      <FlexLayout fullIndex={2} direction="horizontal">
        <div className="v-timeline-item-label">{props.label}</div>
        <div className="v-timeline-item-icon">
          <div className="v-timeline-item-icon-content">
            <span className="v-timeline-item-icon-text-hide" style={{ textIndent: '-999px' }}>
              ICON
            </span>
            <div className="v-timeline-item-icon-outside">
              {props.icon ? props.icon : <div className="v-timeline-item-icon-inside"></div>}
            </div>
          </div>
          <div className="v-timeline-item-icon-line"></div>
        </div>
        <div className="v-timeline-item-content">{props.children}</div>
      </FlexLayout>
    </div>,
  );
};
